import { Routes } from '@angular/router';

import { SignInPageComponent } from './pages/sign-in-page/sign-in-page.component';
import { ExternalAuthCallbackComponent } from './pages/external-auth-callback/external-auth-callback.component';

export const authRoutes: Routes = [
	{
		path: 'auth',
		children: [
			{
				path: 'sign-in',
				component: SignInPageComponent
			},
			{
				path: 'external/callback',
				component: ExternalAuthCallbackComponent
			},
			{
				path: '',
				redirectTo: 'sign-in',
				pathMatch: 'full'
			}
		]
	}
];
